import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'asap-curriculum',
  template: 
  `
    <app-curriculum *ngIf="userID" [userID]="userID" ></app-curriculum>
    <app-curriculum *ngIf="!userID"></app-curriculum>
  `,
  styles: []
})
export class AsapCurriculumComponent implements OnInit {

  public userID;

  constructor(public route: ActivatedRoute) {
    route.params.subscribe((params) => {
      this.userID = params.id;
    });
  }

  ngOnInit() {
  }

}
